import GeolocationCta from './GeolocationCta'

export type FreeSearchPanelProps = {
  onUseCurrentLocation: () => void
}

const FreeSearchPanel = ({ onUseCurrentLocation }: FreeSearchPanelProps) => (
  <div className="flex h-[48px] flex-1 items-center justify-start whitespace-nowrap md:justify-end">
    <GeolocationCta onClick={onUseCurrentLocation} />
  </div>
)

export default FreeSearchPanel
